import React, { FC } from 'react';
import { Container } from '@components/atoms/Container';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import styles from './SocialBanner.module.css';

export interface SocialBannerProps {
    title?: string;
    subtitle?: string;
    images?: string[];
}

export const SocialBanner: FC<SocialBannerProps> = ({ 
    title = 'Partilha com #bairrodigital',
    subtitle = 'A cada passo uma história para contar.',
    images = []
}) => {
    
    const displayImages = images.length > 0 ? images : [];

    return (
        <section className={styles.socialBanner}>
            <Container>
                <div className={styles.bannerHeader}>
                    <Typography 
                        tagVariant={TypographyTagVariants.h2} 
                        color="light" 
                        classes={styles.bannerTitle}>
                        {title}
                    </Typography>
                    <Typography 
                        color="light" 
                        classes={styles.bannerSubtitle}>
                        {subtitle}
                    </Typography>
                </div>
            </Container>

            <div className={styles.imagesGrid}>
                {displayImages.slice(0, 6).map((image, index) => (
                    <div key={index} className={styles.imageCard}>
                        <img
                            src={image}
                            alt={`Social post ${index + 1}`}
                            className={styles.imageItem}
                        />
                    </div>
                ))}
            </div>
        </section>
    );
};
